import ApiService from './ApiService'

export default class IracemaService extends ApiService {
  constructor() {
    super('https://script.google.com/macros/s/AKfycbxIdEz0gD7slBfooWjR_YYixNC7Tcz2MM321m_H2UR-gdEtC1E/exec')
  }
}



// WEBPACK FOOTER //
// ./src/services/IracemaService.js